'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagLkAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-3.8147e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 1.2517e-06 20C1.2517e-06 13.3333 0.000255184 6.66667 -3.8147e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M-3.8147e-05 0H28V20H1.2517e-06L-3.8147e-05 0Z", fill: "#FFBF19" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.6665 1.33331H25.3332C26.0696 1.33331 26.6665 1.93027 26.6665 2.66665V17.3333C26.6665 18.0697 26.0696 18.6666 25.3332 18.6666H10.6665V1.33331Z",
          fill: "#A52531"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.3335 2.66665C1.3335 1.93027 1.93045 1.33331 2.66683 1.33331H5.3335V18.6666H2.66683C1.93045 18.6666 1.3335 18.0697 1.3335 17.3333V2.66665Z",
          fill: "#03664F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5.3335 1.99998C5.3335 1.63179 5.63197 1.33331 6.00016 1.33331H8.66683C9.03502 1.33331 9.3335 1.63179 9.3335 1.99998V18C9.3335 18.3682 9.03502 18.6666 8.66683 18.6666H6.00016C5.63197 18.6666 5.3335 18.3682 5.3335 18V1.99998Z",
          fill: "#FF6816"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.3333 3.33333C13.3333 3.70152 13.0349 4 12.6667 4C12.2985 4 12 3.70152 12 3.33333V2.66667H12.6667C13.0349 2.66667 13.3333 2.96514 13.3333 3.33333Z",
          fill: "#FFBF18"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M24.0002 3.33333C24.0002 3.70152 24.2986 4 24.6668 4C25.035 4 25.3335 3.70152 25.3335 3.33333V2.66667H24.6668C24.2986 2.66667 24.0002 2.96514 24.0002 3.33333Z",
          fill: "#FFBF18"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M24.6668 16C24.2986 16 24.0002 16.2985 24.0002 16.6667C24.0002 17.0349 24.2986 17.3334 24.6668 17.3334H25.3335V16.6667C25.3335 16.2985 25.035 16 24.6668 16Z",
          fill: "#FFBF18"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.3333 16.6667C13.3333 16.2985 13.0349 16 12.6667 16C12.2985 16 12 16.2985 12 16.6667V17.3333H12.6667C13.0349 17.3333 13.3333 17.0349 13.3333 16.6667Z",
          fill: "#FFBF18"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.9999 12.5736C15.9999 12.2568 15.7431 12 15.4263 12C15.3646 12 15.3035 11.9902 15.2455 11.9694C14.8597 11.8316 13.3332 11.2491 13.3332 10.6667C13.3332 10.3018 13.5329 9.937 13.7137 9.68143C13.8711 9.4589 13.9297 9.16973 13.8331 8.91484C13.6065 8.31687 13.2396 7.22836 13.3332 6.66669C13.3831 6.36754 13.5822 6.1056 13.812 5.8949C14.1677 5.56881 14.6665 5.87699 14.6665 6.35951V8.92133C14.6665 9.17384 14.8092 9.40469 15.0351 9.51761L15.7116 9.85587C15.8837 9.94195 16.0917 9.90821 16.2278 9.77209C16.4436 9.55625 16.3846 9.19238 16.1116 9.05587L15.3332 8.66669V8.00002C15.6653 8.00002 15.771 7.55227 15.474 7.40373L15.3332 7.33335V6.66669H16.3904C16.5672 6.66669 16.7368 6.59645 16.8618 6.47142L17.1379 6.19528C17.263 6.07026 17.4325 6.00002 17.6093 6.00002H18.2545C18.507 6.00002 18.7379 6.14269 18.8508 6.36854L19.2097 7.08636C19.2888 7.24451 19.3018 7.42759 19.2459 7.59532L18.959 8.45587C18.8151 8.88755 19.1364 9.33335 19.5915 9.33335H21.7831C21.9219 9.33335 22.055 9.27822 22.1531 9.18008C22.4057 8.92751 22.3366 8.50173 22.0171 8.34199L21.474 8.0704C21.3814 8.02411 21.2793 8.00002 21.1758 8.00002H20.6665C20.2983 8.00002 19.9999 7.70154 19.9999 7.33335V6.94283C19.9999 6.76602 20.0701 6.59645 20.1951 6.47142L20.6665 6.00002V6.66669C20.6665 7.03487 20.965 7.33335 21.3332 7.33335H22.2545C22.507 7.33335 22.7379 7.47602 22.8508 7.70188L23.2797 8.55975C23.3151 8.63048 23.3376 8.70659 23.3448 8.78533C23.3755 9.12089 23.4486 10.0897 23.3332 10.6667C23.2397 11.1342 22.9779 11.5669 22.8116 11.8061C22.7222 11.9347 22.6665 12.0858 22.6665 12.2424V14.1574C22.6665 14.4387 22.4385 14.6667 22.1572 14.6667C21.7786 14.6667 21.5324 14.2683 21.7017 13.9296L21.9295 13.4741C21.9738 13.3855 21.9738 13.2812 21.9295 13.1926L21.898 13.1296C21.7573 12.8482 21.3332 12.9484 21.3332 13.263C21.3332 13.3093 21.3224 13.3549 21.3017 13.3963L20.8313 14.3371C20.7303 14.5391 20.5239 14.6667 20.298 14.6667C19.8547 14.6667 19.5664 14.2002 19.7647 13.8037L19.9295 13.4741C19.9758 13.3815 19.9999 13.2795 19.9999 13.176V12.6667C19.9999 12.2985 19.7014 12 19.3332 12H17.9999C17.6317 12 17.3332 12.2985 17.3332 12.6667V13.176C17.3332 13.2795 17.3091 13.3815 17.2628 13.4741L16.8313 14.3371C16.7303 14.5391 16.5239 14.6667 16.298 14.6667C15.8547 14.6667 15.5664 14.2002 15.7647 13.8037L15.9295 13.4741C15.9758 13.3815 15.9999 13.2795 15.9999 13.176V12.5736Z",
          fill: "#FFBF18"
        }
      )
    ]
  }
);
const VpFlagLkAsset = forwardRef(FlagLkAsset);

export { VpFlagLkAsset as default };
